import { useParams, Link } from 'react-router-dom';
import { Seo, SITE_URL } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ArticleBody, ArticleMeta, Disclaimer, ArticleCard } from '../components/ArticleParts';
import { magazineArticles } from '../content/magazine';
import NotFound from './NotFound';

export default function MagazinArtikel() {
  const { slug } = useParams();
  const article = magazineArticles.find((a) => a.slug === slug);
  if (!article) return <NotFound />;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: article.title,
    description: article.metaDescription,
    author: { '@type': 'Organization', name: 'Felix Genuss Redaktion', url: SITE_URL },
    publisher: { '@id': `${SITE_URL}/#organization` },
    datePublished: article.veroeffentlicht,
    dateModified: article.geaendert,
    inLanguage: 'de',
    mainEntityOfPage: `${SITE_URL}/magazin/${article.slug}`,
  };

  const others = magazineArticles.filter((a) => a.slug !== slug);

  return (
    <>
      <Seo title={article.seoTitle} description={article.metaDescription} path={`/magazin/${article.slug}`} jsonLd={jsonLd} />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Magazin', href: '/magazin' }, { label: article.title }]} />

      <article className="container-site mt-10 max-w-3xl" data-testid="magazin-artikel">
        <p className="eyebrow">{article.kategorie}</p>
        <h1 className="mt-3 font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">{article.title}</h1>
        <ArticleMeta article={article} />
        <p className="mt-6 text-lg leading-relaxed text-brand-brown/85">{article.teaser}</p>
        <hr className="gold-rule mt-8" />
        <div className="mt-10">
          <ArticleBody article={article} />
        </div>
        <Disclaimer />
        <p className="mt-10 text-sm leading-relaxed text-brand-brown-soft">
          Mehr über unseren Chefverkoster erfährst du auf der Seite{' '}
          <Link to="/felix" className="link-inline">Über Felix</Link>.
        </p>
      </article>

      {others.length > 0 && (
        <aside className="container-site mt-16" aria-labelledby="weiterlesen-heading">
          <h2 id="weiterlesen-heading" className="font-serif text-2xl font-bold sm:text-3xl">Weiterlesen</h2>
          <div className="mt-8 grid gap-6 sm:grid-cols-2">
            {others.map((a) => (
              <ArticleCard key={a.slug} article={a} basePath="/magazin" />
            ))}
          </div>
        </aside>
      )}
    </>
  );
}
